
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punedarshaninnovacrysta() {



    const cardData =
    {
        keyword: 'Pune Darshan Innova Crysta Cabs',
        heading: 'Meghana Cab : Pune Darshan Innova Crysta Cabs',
        headingDescription: 'Meghana Cab offers Pune Darshan Innova Crysta Cabs, designed for travelers seeking a comfortable, luxurious, and hassle-free sightseeing experience in and around Pune. Perfect for family trips, corporate outings, or out-of-town guests, our Innova Crysta vehicles come with plush leather interiors, spacious seating, and ample luggage space—ideal for full‑day excursions. Explore iconic Pune attractions like Shaniwar Wada, Aga Khan Palace, Sinhagad Fort, Parvati Hill, and Osho Ashram with experienced chauffeurs who double as local guides.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is an iconic symbol of Pune’s Maratha legacy. Once a grand palace complex with seven stories and ornate halls, it was tragically gutted by a fire in 1828. Today, its massive gates, fortified walls, lotus-shaped fountains, and sprawling gardens continue to attract history lovers. Legends of palace intrigue and haunting folklore make it one of Pune’s most visited historical sites. The evening light-and-sound show offers a captivating audio-visual journey into Maratha history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "This majestic palace was built in 1892 by Sultan Aga Khan III and holds a revered place in India’s freedom struggle. It served as a place of incarceration for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace, surrounded by serene gardens, now functions as a memorial and museum, housing Gandhi’s belongings, rare photographs, and his ashes. It is a peaceful oasis that blends architecture, history, and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 35 km southwest of Pune, Sinhagad Fort is a hilltop military outpost famed for the 1670 Battle of Sinhagad, where Maratha warrior Tanaji Malusare displayed unparalleled bravery. Trekkers flock to this fort year-round for its rugged paths, panoramic views, and rustic food stalls serving local delicacies like 'pithla-bhakri'. The ruins of gates, watchtowers, and memorials transport visitors back to the era of valor and strategy. Monsoon is an especially magical time to visit."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Spread across 28 acres in Koregaon Park, the Osho Ashram is one of the world’s largest meditation centers. It blends Zen-inspired architecture with lush gardens and modern amenities. The resort offers dynamic meditations, healing therapies, creative workshops, and wellness programs. Visitors from over 100 countries come here for personal transformation, silence, and rejuvenation. It’s a unique sanctuary where mindfulness meets luxury, nestled within Pune’s urban heart."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "Dedicated to Lord Ganesha, this 130-year-old temple is a spiritual landmark in Pune’s Budhwar Peth area. The temple’s 7.5-foot-tall idol is adorned with over 40 kg of gold and is revered by politicians, celebrities, and millions of devotees. It becomes the epicenter of the city’s Ganesh Chaturthi celebrations, drawing lakhs of people. The temple is known for its vibrant atmosphere, intricate decorations, and a strong connection to Pune’s cultural identity."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, Pataleshwar is carved from a single basalt rock and features a sanctum with a Shiva lingam, a circular Nandi mandapa, and intricately carved pillars. Located on busy Jangli Maharaj Road, this monument offers a peaceful spiritual retreat amidst urban life. It stands as a testament to ancient Indian architecture and artistry and is a lesser-known gem in Pune’s heritage circuit."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This unique museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing the everyday life of India’s past. From ornate doors and miniature paintings to musical instruments, sculptures, and antique utensils, the exhibits reflect the richness of Indian craftsmanship. The highlight is the reconstructed 'Mastani Mahal', representing the royal elegance of the Maratha court. Audio guides and themed galleries make this a must-visit cultural destination."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Rising 2,100 feet above sea level, Parvati Hill offers a scenic trek with 103 stone steps leading to a hilltop complex of Peshwa-era temples. The Parvati Temple, dedicated to Goddess Parvati, offers panoramic views of Pune. A small museum here showcases artifacts from the Peshwa dynasty. The spot is perfect for early morning visits, photography, and spiritual reflection—especially during sunrise and winter months."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spread across 130 acres on the southern outskirts of Pune, this well-maintained zoological park includes a snake park, zoo, and lake. It houses tigers, leopards, elephants, deer, crocodiles, and a wide variety of birds. It’s an educational hotspot for children and families, offering nature trails, animal adoption programs, and boating facilities. The zoo is a perfect mix of wildlife conservation and recreation."
  },
  {
    "title": "Shinde Chhatri",
    "description": "Located in Wanowrie, Shinde Chhatri is a stunning 18th-century memorial dedicated to Maratha military leader Mahadji Shinde. The structure features elaborate Rajasthani-style domes, colorful stained-glass windows, and an atmosphere of serene grandeur. The adjoining Shiva temple and the samadhi (final resting place) of Shinde add to the historical depth. It’s one of Pune’s lesser-known heritage sites, rich in architecture and historical importance."
  }
],

"services": [
  {
    "name": "Pune Darshan Innova Crysta Cab Booking",
    "description": "Book a premium Innova Crysta cab for Pune Darshan and explore the city’s top attractions in style and comfort. Whether it’s historical sites, temples, museums, or gardens, our cabs come with professional chauffeurs, ensuring a relaxed and enriching sightseeing experience for families, tourists, or corporate guests."
  },
  {
    "name": "Local Sightseeing Innova Crysta Pune",
    "description": "Plan a full-day local sightseeing tour in Pune with our spacious and AC-enabled Innova Crysta. Visit popular spots like Shaniwar Wada, Aga Khan Palace, Parvati Hill, Saras Baug, and more in a reliable and luxurious vehicle that’s ideal for groups or families."
  },
  {
    "name": "Chauffeur Driven Pune Darshan Innova Crysta",
    "description": "Sit back and enjoy your Pune Darshan while our experienced chauffeurs handle the driving. Our professional drivers are punctual, courteous, and familiar with the best sightseeing routes—making your trip hassle-free and time-efficient."
  },
  {
    "name": "Affordable Pune Darshan Innova Crysta Taxi",
    "description": "Experience quality travel at a reasonable price with our affordable Innova Crysta taxis for Pune Darshan. Enjoy luxury-level comfort, ample space, and smooth rides—all within a budget-friendly package perfect for city exploration."
  },
  {
    "name": "Family Pune Darshan Innova Crysta",
    "description": "Make your family’s Pune Darshan trip memorable with our Innova Crysta, offering 6- or 7-seater configurations, AC, and generous legroom. It’s the ideal choice for families looking for a safe, clean, and comfortable sightseeing vehicle."
  },
  {
    "name": "Online Booking Pune Darshan Innova Crysta",
    "description": "Book your Pune Darshan Innova Crysta cab online quickly and securely. Choose your pickup location, customize your tour plan, and get instant confirmation—all from the convenience of your phone or laptop."
  },
  {
    "name": "Premium Pune Darshan Innova Crysta Cab",
    "description": "Upgrade your city tour with a premium Innova Crysta for Pune Darshan. Our vehicles feature plush interiors, captain seats, air conditioning, and a smooth ride experience—ideal for VIP guests, executives, or those looking for first-class comfort during their sightseeing."
  },
  {
    "name": "AC Innova Crysta Taxi Pune Darshan",
    "description": "Beat the heat and explore Pune comfortably with our air-conditioned Innova Crysta taxis. This service is perfect for full-day city tours, ensuring a cool and pleasant journey while visiting historical landmarks and cultural hotspots."
  }
],
"tableData": [
  ["Pune Darshan Innova Crysta Cab Booking", "Local Sightseeing Innova Crysta Pune"],
  ["Chauffeur Driven Pune Darshan Innova Crysta", "Affordable Pune Darshan Innova Crysta Taxi"],
  ["Family Pune Darshan Innova Crysta", "Online Booking Pune Darshan Innova Crysta"],
  ["Premium Pune Darshan Innova Crysta Cab", "AC Innova Crysta Taxi Pune Darshan"]
],



"whychoose": [
    {
        "WhyChooseheading": "Comfortable Innova Crysta Cabs for Pune Darshan",
        "WhyChoosedescription": "Explore the cultural, historical, and modern attractions of Pune with our Pune Darshan Innova Crysta cabs. Perfect for family groups, tourists, and weekend explorers looking for a comfortable and spacious ride across the city."
    },
    {
        "WhyChooseheading": "Spacious and Premium Travel Experience",
        "WhyChoosedescription": "Our Innova Crysta cabs offer luxurious interiors, excellent legroom, and a smooth ride. With capacity for 6–7 passengers and ample luggage space, it’s perfect for a full day of sightseeing without discomfort."
    },
    {
        "WhyChooseheading": "Professional Drivers with City Route Knowledge",
        "WhyChoosedescription": "Our courteous and experienced drivers are well-acquainted with all major Pune landmarks—Shaniwar Wada, Aga Khan Palace, Dagdusheth Ganpati, Parvati Hills, Saras Baug, and more—ensuring a well-planned and informative city tour."
    },
    {
        "WhyChooseheading": "Customizable Pune Darshan Itineraries",
        "WhyChoosedescription": "We offer flexible Pune Darshan packages. Choose from half-day, full-day, or customized plans with your preferred destinations, pickup and drop points, and stopovers at restaurants, parks, or shopping spots."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "Every Innova Crysta is fully cleaned and sanitized before your ride. Our cabs are air-conditioned, comfortable, and regularly serviced for a safe and enjoyable experience throughout your city tour."
    },
    {
        "WhyChooseheading": "Affordable, Transparent Pricing with No Hidden Fees",
        "WhyChoosedescription": "Enjoy all-inclusive pricing with no surprise charges. Our packages cover driver allowances, fuel, and local tolls, giving you complete transparency and value for money."
    },
    {
        "WhyChooseheading": "Perfect for Tourists, Family Outings, and Group Travel",
        "WhyChoosedescription": "Whether you're showing guests around, planning a family day out, or organizing a group tour, the Innova Crysta ensures everyone travels together in style and comfort during the Pune Darshan."
    },
    {
        "WhyChooseheading": "Easy Booking and 24/7 Support",
        "WhyChoosedescription": "Book your Pune Darshan cab easily through our website or helpline. Our team is available round the clock to assist with itinerary planning, changes, or any special travel needs."
    }
]


























    }

const faqData = [
    {
        question: "How can I book an Innova Crysta for Pune Darshan?",
        answer: "You can book your cab by calling Meghana Cab at +91 9075462128 or through our website for easy and quick booking."
    },
    {
        question: "What is included in the Pune Darshan package with Innova Crysta?",
        answer: "The package includes a full-day sightseeing trip to popular attractions in Pune with an experienced driver and a comfortable Innova Crysta."
    },
    {
        question: "Which places are covered in Pune Darshan?",
        answer: "Common spots include Shaniwar Wada, Aga Khan Palace, Saras Baug, Parvati Hill, Dagdusheth Ganpati, Katraj Zoo, and more. Custom plans are also available."
    },
    {
        question: "Is the cab available for half-day and full-day Pune Darshan?",
        answer: "Yes, we offer both half-day (4 hours/40 km) and full-day (8 hours/80 km) packages."
    },
    {
        question: "How many people can travel in the Innova Crysta?",
        answer: "Innova Crysta comfortably seats 6 to 7 passengers, making it perfect for family or group sightseeing."
    },
    {
        question: "Are the cabs sanitized before every trip?",
        answer: "Yes, we thoroughly clean and sanitize our vehicles before each journey for your safety."
    },
    {
        question: "Are the drivers knowledgeable about Pune's tourist spots?",
        answer: "Yes, our drivers are well-informed about local attractions and can help guide your tour."
    },
    {
        question: "Is it possible to customize the sightseeing itinerary?",
        answer: "Yes, you can customize your Pune Darshan plan according to your preferences and time availability."
    },
    {
        question: "What is included in the fare?",
        answer: "The fare includes fuel and driver charges. Any parking or entrance fees at attractions are additional."
    },
    {
        question: "What payment methods do you accept for Pune Darshan bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Nitin Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“We booked an Innova Crysta for Pune Darshan with family. The cab was clean, comfortable, and the driver was very courteous.”',
    },
    {
        name: 'Ms. Snehal Shinde',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Perfect experience with Meghana Cab’s Pune Darshan service. Covered all major spots in comfort. Highly recommended!”',
    },
];















































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];











const puneDarshanInnovaSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Pune Darshan Innova Crysta Cabs",
  "description": "Book chauffeur-driven Innova Crysta cabs for Pune Darshan local sightseeing. Comfortable, affordable, and premium AC taxi service ideal for family and group tours.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Local Sightseeing Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-darshan-innova-crysta-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Pune Darshan Innova Crysta Cabs | Local Sightseeing Taxi Pune</title>
  <meta
    name="description"
    content="Affordable and premium chauffeur-driven Innova Crysta cabs for Pune Darshan local sightseeing. Book online for family and group tours."
  />
  <meta
    name="keywords"
    content="Pune Darshan Innova Crysta Cab Booking, Local Sightseeing Innova Crysta Pune, Chauffeur Driven Pune Darshan Innova Crysta, Affordable Pune Darshan Innova Crysta Taxi, Family Pune Darshan Innova Crysta, Online Booking Pune Darshan Innova Crysta, Premium Pune Darshan Innova Crysta Cab, AC Innova Crysta Taxi Pune Darshan"
  />
  <script type="application/ld+json">
    {JSON.stringify(puneDarshanInnovaSchema)}
  </script>
</Helmet>


            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/40.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punedarshaninnovacrysta;